import React from 'react'
import Day from './Day'

const Month = ({month}) => {
  return (
    <div className='grid-data'>
      {month.map((row,i)=>(
        <React.Fragment key={i}>
          {row.map((day,idx)=>(
            <Day day={day} key={idx} rowIdx={i} dayType={"month"}/>
          ))}
        </React.Fragment>
      ))}

    </div>
  )
}

export default Month